import styled from "styled-components";

const StickyButtons = styled.div`
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: ${({ theme }) => theme.zIndex[2]};
  display: flex;
  gap: 16px;
  align-items: flex-end;
`;

export default StickyButtons;
